import { Options } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import AnchorLink from 'components/AnchorLink';
import React, { ReactNode } from 'react';
import renderRichText, {
  ContentfulRichText,
} from 'utils/contentful/renderRichText';

import * as S from './styles';

type RichTextWrapperProps = {
  contentfulRichText: ContentfulRichText;
};

const isValidURI = (url: string) =>
  url.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
  ) !== null;

const RichTextWrapper = ({
  contentfulRichText,
}: RichTextWrapperProps): JSX.Element => {
  // This is needed to overide the default behavior of the render. We want to open the links on another tab when they are not anchor links
  const richTextOptions: Options = {
    renderNode: {
      [INLINES.HYPERLINK]: (node): ReactNode => {
        /* @ts-ignore (ignoring this because the link text comes in the content array)*/
        const linkText = node.content[0].value;
        const isURI = isValidURI(node.data.uri);

        return isURI ? (
          <a href={`${node.data.uri}`} target="_blank" rel="noreferrer">
            {linkText}
          </a>
        ) : (
          <AnchorLink href={`#${node.data.uri}`} offset="50">
            {linkText}
          </AnchorLink>
        );
      },
    },
  };

  return (
    <S.Wrapper>{renderRichText(contentfulRichText, richTextOptions)}</S.Wrapper>
  );
};

export default RichTextWrapper;
